import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { tokenStore } from "@/lib/token";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { beginOAuthSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      // Handle Google OAuth callback with authorization code
      if (code) {
        try {
          const response = await axios.post(`${API}/auth/google/exchange`, { code });
          window.history.replaceState(null, "", "/");

          if (response.data.pending_signup) {
            // No account exists yet: nothing was saved server-side. Stash the
            // pending signup and let Onboarding create the account once the
            // password is validated there.
            sessionStorage.setItem("pending_signup", JSON.stringify({
              pending_token: response.data.pending_token,
            }));
            navigate("/onboarding", { replace: true });
            return;
          }

          const { access_token, user, needs_password_setup, needs_password_then_2fa } = response.data;

          if (needs_password_setup) {
            // Compte hérité sans mot de passe VantaPulse : ce jeton donne un accès
            // complet (rien à protéger tant qu'aucun mot de passe n'existe), direction
            // onboarding pour en définir un.
            beginOAuthSession(access_token, user);
            navigate("/onboarding", { replace: true });
          } else {
            // Compte déjà protégé par un mot de passe, ou par l'A2F sans mot de passe :
            // le jeton reçu est volontairement limité (voir create_oauth_pending_token
            // côté backend) et ne permet que de vérifier ce mot de passe / ce code (puis
            // l'A2F) sur /password-login. On ne renseigne pas `user` tout de suite : le
            // vrai accès n'est accordé qu'après.
            if (needs_password_then_2fa) {
              sessionStorage.setItem("oauth_needs_password_setup_after", "1");
            }
            tokenStore.set(access_token);
            navigate("/password-login", { replace: true });
          }
        } catch (error) {
          // Message affiché ici : une navigation interne ne relit pas ?auth_error=.
          toast.error(error?.response?.data?.detail || "La connexion Google n'a pas abouti. Réessayez.");
          navigate("/", { replace: true });
        }
        return;
      }

      navigate("/", { replace: true });
    };

    processAuth();
  }, [navigate, beginOAuthSession]);

  return (
    <div className="min-h-screen bg-vanta-base flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-text-secondary">Connexion en cours...</p>
      </div>
    </div>
  );
}
